var map = {
  "./cs.json": [
    "LO0",
    [
      "9z"
    ]
  ],
  "./en.json": [
    "a5q",
    [
      "k"
    ]
  ],
  "./pl.json": [
    "UeU",
    [
      "6u"
    ]
  ],
  "./ru.json": [
    "Ca",
    [
      "g1"
    ]
  ],
  "./tr.json": [
    "xDt",
    [
      "nb"
    ]
  ],
  "./ja.json": [
    "vO",
    [
      911
    ]
  ],
  "./zh.json": [
    "pty",
    [
      "n5"
    ]
  ],
  "./pt-br.json": [
    "ns",
    [
      "1n"
    ]
  ],
  "./de.json": [
    "quK",
    [
      "wka"
    ]
  ],
  "./es.json": [
    "UJ",
    [
      "as"
    ]
  ],
  "./fr.json": [
    "ze",
    [
      "po"
    ]
  ],
  "./it.json": [
    "qRe",
    [
      "cc"
    ]
  ],
  "./ko.json": [
    "SLw",
    [
      "sp4"
    ]
  ],
  "./pt.json": [
    "b0x",
    [
      "p"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "JQq";
module.exports = __rspack_async_context;
